export { default } from "./GovernancesMspa";
